import "./index.css";
// slick-carousel
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// swiper
// import "swiper/css";
// import "swiper/css/navigation";
// scroll bar
import "simplebar/src/simplebar.css";
// lazy image
import "lazysizes";
import "lazysizes/plugins/attrchange/ls.attrchange";
import "lazysizes/plugins/object-fit/ls.object-fit";
import "lazysizes/plugins/parent-fit/ls.parent-fit";

import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "reduxjs-toolkit-persist/integration/react";

import store, { persistor } from "./redux";
import { AuthProvider } from "./contexts/AuthContext";

import reportWebVitals from "./reportWebVitals";

function render() {
  const App = require("./App").default;
  ReactDOM.render(
    <Provider store={store}>
      <PersistGate
        loading={
          <div style={{ color: "white" }}>Afrikast Loading...........</div>
        }
        persistor={persistor}
      >
        <React.StrictMode>
          <BrowserRouter>
            <AuthProvider>
              <App />
            </AuthProvider>
          </BrowserRouter>
        </React.StrictMode>
      </PersistGate>
    </Provider>,
    document.getElementById("root")
  );
}

render();

if (process.env.NODE_ENV === "development" && module.hot) {
  module.hot.accept("./App", render);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
